import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { observeElementOffset, useVirtualizer } from "@tanstack/react-virtual";
import { memo, useEffect, useRef, useState } from "react";
const _TreeList = (param)=>{
    let { className, getEstimateSize, initialIndex, items, renderListItem, scrollElement, ...restOfProps } = param;
    var _listRef_current, _virtualItems_;
    const [hasScrolled, setHasScrolled] = useState(!initialIndex);
    const listRef = useRef(null);
    var _listRef_current_offsetTop;
    const virtualizer = useVirtualizer({
        count: items.length,
        estimateSize: getEstimateSize,
        observeElementOffset,
        overscan: 5,
        scrollMargin: (_listRef_current_offsetTop = (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.offsetTop) !== null && _listRef_current_offsetTop !== void 0 ? _listRef_current_offsetTop : 0,
        getScrollElement: ()=>scrollElement
    });
    const virtualItems = virtualizer.getVirtualItems();
    /**
   * Scroll to the initial index if it exists.
   */ useEffect(()=>{
        if (initialIndex !== undefined && initialIndex > -1) {
            /**
       * We need to check if virtualItems exists to prevent the incorrect scroll position
       */ if (virtualItems.length && !hasScrolled) {
                virtualizer.scrollToIndex(initialIndex, {
                    behavior: "smooth"
                });
                setHasScrolled(true);
            }
        }
    }, [
        hasScrolled,
        initialIndex,
        virtualItems,
        virtualizer
    ]);
    var _virtualItems__start;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("relative w-full", className),
        "data-testid": "TREE_LIST",
        ref: listRef,
        style: {
            height: virtualizer.getTotalSize()
        },
        ...restOfProps,
        children: /*#__PURE__*/ _jsx("div", {
            className: "absolute left-0 top-0 flex w-full flex-col",
            style: {
                transform: "translateY(".concat(((_virtualItems__start = (_virtualItems_ = virtualItems[0]) === null || _virtualItems_ === void 0 ? void 0 : _virtualItems_.start) !== null && _virtualItems__start !== void 0 ? _virtualItems__start : 0) - virtualizer.options.scrollMargin, "px)")
            },
            children: virtualItems.map((item)=>/*#__PURE__*/ _jsx("div", {
                    "data-index": item.index,
                    ref: virtualizer.measureElement,
                    children: renderListItem({
                        data: items[item.index],
                        index: item.index,
                        scrollToIndex: virtualizer.scrollToIndex
                    })
                }, item.key))
        })
    });
};
export const TreeList = /*#__PURE__*/ memo(_TreeList);
